export default "__VITE_ASSET__S30flOi2__"